import { useState } from "react";
// import { doDelete } from "../../api/BaseAPI";
import { useDispatch } from "react-redux";
// import { authActions } from "../../redux/reducer/AuthReducer";
import { Button, message, Modal } from "antd";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import style from "./Modal.module.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constant/routeConstant";
import PrimaryButton from "../button/PrimaryButton";
import SecondaryButton from "../button/SecondaryButton";
import { authActions } from "../../store/reducer/authReducer";
import { GROLOG_URL } from "../../constant/apiConstant";
import SuccessModal from "./SuccessModal";
import ModalSuccessDelete from "./ModalSuccessDelete";
import ModalFailedDelete from "./ModalFailedDelete";
import { useSelector } from "react-redux";

const CustomDelete = (props) => {
  const api = GROLOG_URL;
  const { token, client_id, grolog_account_id, userId } = useSelector((state) => state.auth);
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;  let { t } = useTranslation();
  const dispatch = useDispatch();
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [failedModalOpen, setFailedModalOpen] = useState(false)
  const navigate = useNavigate();
  const form = {
    updated_at: props.data,
  };
  const formDriver = {
    updated_at_driver: props.data,
  };

  const doDelete = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "DELETE";
    const headers = { "Authorization": tkn };
    const request = { url, method, headers, data };
    return axios(request);
  };
  const deleteHandler = async () => {
    let data = props.url === "driver" ? formDriver : form;
    let res = await doDelete(`/${props.url}/${props.id}?${param}`, token, data);
    if(res.data.payload.status.code === "OK"){
      setSuccessModalOpen(true); 
    }else{
      setFailedModalOpen(true)
    }
    dispatch(authActions.refreshPage(1));
    dispatch(authActions.refreshPage(1));
    props.action();
    props.refresh();
    navigate(props.route, { state: false });
  };
  return (
    <>
      <ModalFailedDelete
        show={failedModalOpen}
        onOk={() => setFailedModalOpen(false)}
        closable={false}
        width={414}
        className={style.deleteModal}
        okText="Ok"
        title="Data Cant be deleted"
        description="Because Driver already made an order trip"
      />

      <ModalSuccessDelete
        show={successModalOpen}
        action={() => setSuccessModalOpen(false)}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description="Your data has been deleted"
      />
      {/* {props.delete ? (
        <> */}
      <Modal
        visible={props.delete}
        closable={false}
        centered={true}
        width="464px"
        footer={null}
      >
        <div className={style.ModalTitle}>Delete Data?</div>
        <div className={style.ModalSubTitle}>
          Are you sure for delete
          <br />
          {props.id} - {props.title}?
        </div>

        <div
          style={{
            justifyItems: "center",
            margin: 0,
            padding: 0,
            display: "flex",
          }}
        >
          <div className="mr-8 ml-9">
            <SecondaryButton
              text={t("Yes, delete")}
              action={() => deleteHandler()}
            />
          </div>

          <PrimaryButton
            text={t("USER_DETAIL:CANCEL")}
            action={() => props.action()}
          />
        </div>
      </Modal>
    </>
    // ) : null}
    // </>
  );
};

export default CustomDelete;
